import { FILTER_LABEL_MAPPING, FilterNames } from '../../constants';
import { IFilterStateHandler, ISelectFilterOption, ISelectFilter } from '../../../shop-ui/components/search-page/interfaces';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import AbstractSelectFilterHandler from '../../../shop-ui/includes/filter-state/AbstractSelectFilterHandler';

export default class SaleFilterHandler extends AbstractSelectFilterHandler implements IFilterStateHandler {
    public createQueryParams = (filter: ISelectFilter, params: object): void => {
        const selectedFilterOptionValues = filter.options
            .filter(option => option.selected)
            .map(selectedOption => selectedOption.value);

        params[FilterNames.SALE] = !selectedFilterOptionValues.length ? null : selectedFilterOptionValues[0];
    };

    public resetQueryParams = (params: object): void => {
        params[FilterNames.SALE] = null;
    }

    public getSelectedOptions = (filter: ISelectFilter): ISelectFilterOption[] => {
        const selectedOptionList = filter.options.filter(option => option.selected);

        if (!selectedOptionList.length) {
            return [];
        }

        return [
            {
                ...selectedOptionList[0],
                label: translate(FILTER_LABEL_MAPPING[FilterNames.SALE], 'article-list').toLocaleUpperCase()
            }
        ];
    }

    public updateSelectedOptions = (filter: ISelectFilter, selectedValues: string[]): void => {
        filter.options = filter.options.map((option: ISelectFilterOption) => {
            option.selected = selectedValues.includes(option.value);

            return option;
        });
    }
}
